var _circle, _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgLinkedinIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 26,
    height: 26,
    viewBox: "0 0 26 26",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 13,
    cy: 13,
    r: 13,
    fill: "white"
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_25_566)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M20.8948 18.7017C20.8948 19.9131 19.9132 20.8947 18.7018 20.8947H7.29827C6.0873 20.8947 5.10529 19.9131 5.10529 18.7017V7.29821C5.10529 6.0868 6.0873 5.10522 7.29827 5.10522H18.7018C19.9132 5.10522 20.8948 6.0868 20.8948 7.29821V18.7017Z",
    fill: "#0078D4"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.05,
    d: "M15.6316 18.7017V14.2723C15.6316 13.5316 15.2724 13.089 14.6702 13.089C14.3128 13.089 14.05 13.2903 13.8899 13.6873C13.8825 13.7153 13.872 13.8298 13.8763 14.1758L13.8772 18.7017H10.8071V10.3684H13.8772V10.8337C14.3255 10.5245 14.875 10.3684 15.5167 10.3684C17.511 10.3684 18.7013 11.725 18.7013 13.9973L18.7018 18.7017H15.6316ZM7.29828 18.7017V10.3684H8.81451C7.936 10.3684 7.29828 9.72278 7.29828 8.83287C7.29828 7.94383 7.94652 7.29822 8.83951 7.29822C9.72196 7.29822 10.3505 7.92585 10.3685 8.82409C10.3685 9.72059 9.71977 10.3684 8.82679 10.3684H10.3685V18.7017H7.29828Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.07,
    d: "M15.8509 18.4825V14.2724C15.8509 13.4071 15.3987 12.8698 14.6701 12.8698C14.1022 12.8698 13.8215 13.2698 13.6864 13.6053C13.6504 13.6926 13.6552 14.0391 13.657 14.1869L13.6579 18.4825H11.0263V10.5878H13.6579V11.3062C14.0066 10.9452 14.568 10.5878 15.5166 10.5878C17.3732 10.5878 18.482 11.8623 18.482 13.9974L18.4824 18.4825H15.8509ZM7.51752 18.4825V10.5878H10.1491V18.4825H7.51752ZM8.81445 10.1492C8.06313 10.1492 7.51752 9.59565 7.51752 8.83293C7.51752 8.07065 8.07366 7.51758 8.83945 7.51758C9.59559 7.51758 10.1337 8.05661 10.1491 8.82854C10.1491 9.59565 9.59296 10.1492 8.82673 10.1492H8.81445Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M7.73682 10.807H9.9298V18.2631H7.73682V10.807ZM8.82673 9.9298H8.81445C8.16006 9.9298 7.73682 9.44208 7.73682 8.83287C7.73682 8.2105 8.17322 7.73682 8.83945 7.73682C9.50655 7.73682 9.91752 8.2105 9.9298 8.83287C9.9298 9.44164 9.50655 9.9298 8.82673 9.9298ZM18.2631 18.2631H16.0701V14.2723C16.0701 13.3083 15.5329 12.6504 14.6701 12.6504C14.0118 12.6504 13.6557 13.0943 13.4829 13.5232C13.4197 13.6767 13.4386 14.1013 13.4386 14.3158V18.2631H11.2456V10.807H13.4386V11.9544C13.7548 11.4649 14.25 10.807 15.5166 10.807C17.0859 10.807 18.2627 11.7938 18.2627 13.9973L18.2631 18.2631Z",
    fill: "white"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_25_566"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 16,
    height: 16,
    fill: "white",
    transform: "translate(5 5)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLinkedinIcon);
export default __webpack_public_path__ + "static/media/linkedin-icon.b01d1e968c59b2cb8113c5ab2550741e.svg";
export { ForwardRef as ReactComponent };